import { Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { departments } from '../../../../../data/header-departments';
import { DepartmentsService } from '../../../../shared/services/departments.service';
import { NavigationLink } from '../../../../shared/interfaces/navigation-link';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../../../auth.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Megamenu } from '../../../../shared/interfaces/megamenu';

@Component({
    selector: 'app-header-departments',
    templateUrl: './departments.component.html',
    styleUrls: ['./departments.component.scss']
})
export class DepartmentsComponent implements OnInit {
    private destroy$: Subject<any> = new Subject();
    
    @Input() menu: Megamenu;
    items: NavigationLink[] = departments;
 
    isOpen = false;
    fixed = false;
    lang = "";

    private get element(): HTMLElement {
        return this.el.nativeElement;
    }

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private renderer: Renderer2,
        private el: ElementRef,
        private service: DepartmentsService,
        private translate: TranslateService,
        public authService: AuthService
    ) {
      this.getAllCategoryList();
    }

    ngOnInit(): void {
        const root = this.element.querySelector('.departments') as HTMLElement;
        const content = this.element.querySelector('.departments__links-wrapper') as HTMLElement;

        this.service.areaElement$.pipe(takeUntil(this.destroy$)).subscribe(areaElement => {
            if (areaElement) {
                this.fixed = true;
                this.isOpen = true;

                if (isPlatformBrowser(this.platformId)) {
                    const areaRect = areaElement.getBoundingClientRect();
                    const areaBottom = areaRect.top + areaRect.height + window.scrollY;

                    root.classList.remove('departments--transition');
                    root.classList.add('departments--fixed', 'departments--opened');

                    const height = areaBottom - (content.getBoundingClientRect().top + window.scrollY);


                    content.getBoundingClientRect(); // force reflow
                } else {
                    this.renderer.addClass(root, 'departments--fixed');
                    this.renderer.addClass(root, 'departments--opened');
                }
            } else {
                this.fixed = false;
                this.isOpen = false;

                if (isPlatformBrowser(this.platformId)) {
                    root.classList.remove('departments--opened', 'departments--fixed');
                    content.style.height = '';
                } else {
                    this.renderer.removeClass(root, 'departments--fixed');
                    this.renderer.removeClass(root, 'departments--opened');
                }
            }
        });

        if (isPlatformBrowser(this.platformId)) {
            fromEvent<MouseEvent>(document, 'mousedown').pipe(
                takeUntil(this.destroy$)
            ).subscribe((event) => {
                if (event.target instanceof HTMLElement && !this.element.contains(event.target)) {
                    this.close();
                }
            });

            fromEvent<TransitionEvent>(content, 'transitionend').pipe(
                takeUntil(this.destroy$)
            ).subscribe((event) => {
                if (event.propertyName === 'height') {
                    root.classList.remove('departments--transition');
                }
            });
        }

        this.lang = this.authService.getLocale();
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
          this.lang = event.lang;
        });

        // this.initTranslate();
    }

    toggle(): void {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open(): void {
        this.isOpen = true;

        const root = this.element.querySelector('.departments') as HTMLElement;
        const content = root.querySelector('.departments__links-wrapper') as HTMLElement;
        const startHeight = content.getBoundingClientRect().height;

        root.classList.add('departments--transition', 'departments--opened');

        const endHeight = content.getBoundingClientRect().height;

        content.style.height = startHeight + 'px';
        content.getBoundingClientRect(); // force reflow
        content.style.height = endHeight + 'px';
    }

    close(): void {
        if (this.fixed || !this.isOpen) {
            return;
        }

        this.isOpen = false;

        const root = this.element.querySelector('.departments') as HTMLElement;
        const content = root.querySelector('.departments__links-wrapper') as HTMLElement;
        const startHeight = content.getBoundingClientRect().height;

        content.style.height = startHeight + 'px';

        root.classList.add('departments--transition');
        root.classList.remove('departments--opened');

        content.getBoundingClientRect(); // force reflow
        content.style.height = '';
    }

    getAllCategoryList(){
      this.authService.start();
      this.authService.getAllCategoryList().subscribe(
          data => {
            if(data['status'] == 'ok'){
              this.items = [];
              var categoryList = data['result'];
              categoryList.forEach((c, index) => {
                var item = {label: '', id: null, url: '', en: '', zh: '', menu: null, childCategoryList: []};
                c.childCategoryList.forEach((c1) => {
                    var item1 = {label: '', id: null, url: '', en: '', zh: '', menu: null, childCategoryList: []};
                    c1.childCategoryList.forEach((c2) => {
                        var item2 = {label: '', id: null, url: '', en: '', zh: '', menu: null, childCategoryList: []};
                        c2.childCategoryList.forEach((c3) => {
                            var item3 = {label: '', id: null, url: '', en: '', zh: '', menu: null, childCategoryList: []};
                            item3.id = c3.id;
                            item3.url = '/classic/shop/' + c3.id;
                            item3.en = c3.categoryLocaleList[0].name;
                            item3.zh = c3.categoryLocaleList[1].name;
                            item2.childCategoryList.push(item3);
                        });
                        item2.id = c2.id;
                        item2.url = '/classic/shop/' + c2.id;
                        item2.en = c2.categoryLocaleList[0].name;
                        item2.zh = c2.categoryLocaleList[1].name;
                        item1.childCategoryList.push(item2);
                    });
                    item1.id = c1.id;
                    item1.url = '/classic/shop/' + c1.id;
                    item1.en = c1.categoryLocaleList[0].name;
                    item1.zh = c1.categoryLocaleList[1].name;
                    item.childCategoryList.push(item1);
                });
                item.id = c.id;
                item.url = '/classic/shop/' + c.id;
                item.en = c.categoryLocaleList[0].name;
                item.zh = c.categoryLocaleList[1].name;
                this.items.push(item);
                
              });
            }else if(data['status'] == 'error'){
              this.authService.showToast("danger", data['errorMessage']);
            }else{
              this.authService.showToast("danger", this.authService.getTranslation("message.generalError"));
            }
            console.log(this.items);
            this.authService.complete();
          },
          error => {
            if(error['error'].errorCode == 400){
              this.authService.showToast("danger", error['error'].message);
            }
            this.authService.complete();
          }
        );
    }
}
